// extracted by mini-css-extract-plugin
export default {"card":"VehicleSelection_card__Mv0l9","vgRow":"VehicleSelection_vgRow__ZQSWi","vehicleRow":"VehicleSelection_vehicleRow__YURqh","selected":"VehicleSelection_selected__M3p6D"};